<template>
  <div>
    <v-card
      v-if="currentLens"
      :color="bkgColorClass[eye]"
      flat
      class="minWidth"
    >
      <v-card-text class="darkerCardText">
        <!-- <div v-for="(lens, index) in data.lenses" :key="index" class="my-2"> -->
        <table>
          <tbody>
            <!-- <tr>
            <td colspan="2">
              Suggested <i>{{ data.lenses[0].lensName | truncate(28) }}</i> lens
            </td>
          </tr> -->
            <tr>
              <th>{{ succinct ? "Pwr" : "Trial Power" }}</th>
              <td>
                <b>{{ currentLens.fullRx }}</b>
              </td>

              <td></td>
            </tr>

            <tr v-if="currentLens.add">
              <th>Add</th>
              <td>
                {{ currentLens.add }}
                <span v-if="currentLens.addModifier"
                  >({{ currentLens.addModifier }})</span
                >
              </td>
            </tr>
            <tr>
              <th>{{ succinct ? "BC" : "Base Curve(s)" }}</th>
              <td>{{ baseCurveList }}</td>
            </tr>
            <tr>
              <th>{{ succinct ? "Diam" : "Diameters(s)" }}</th>
              <td>{{ diamList }}</td>
            </tr>

            <tr>
              <th>{{ succinct ? "VA" : "Potential VA" }}</th>
              <td>
                {{ currentLens.chartVA }}

                <v-tooltip
                  v-if="showWarning && currentLens.va > 27"
                  open-on-click
                  open-on-hover
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="warning" v-bind="attrs" v-on="on" small>
                      mdi-alert
                    </v-icon>
                  </template>
                  <span
                    >VA will be limited by this lens's available powers.
                  </span></v-tooltip
                >
              </td>
            </tr>
            <tr>
              <th>{{ succinct ? "Off" : "Uncorrected Rx" }}</th>
              <td>{{ currentLens.rxDiff }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </div>
  <!-- {{ data }} -->
  <!-- </div> -->
</template>

<script>
// import Name from "../dir/file";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "TrialSuggestionCard",
  mixins: [StyleUtilities],
  props: {
    data: null,
    eye: {
      type: String,
      required: true,
    },
    succinct: null,
    showWarning: null,
  },
  data: function () {
    return {
      currentLensId: 0,
    };
  },
  methods: {
    truncateList: function (arr) {
      if (!arr) return null;
      if (arr.length > 5)
        return `${arr[0]}, ${arr[1]} ... ${arr[arr.length - 2]}, ${
          arr[arr.length - 1]
        } `;
      return arr.join(", ");
    },
  },
  computed: {
    eyeColor: function () {
      if (!this.eye) return null;
      return this.bgColor[this.eye];
    },
    currentLens: function () {
      if (!this.data?.lenses) return null;
      if (!this.data.lenses[this.currentLensId]) return null;
      return this.data.lenses[this.currentLensId];
    },
    baseCurveList: function () {
      return this.truncateList(this.currentLens?.baseCurve);
    },
    diamList: function () {
      return this.truncateList(this.currentLens?.diameter);
    },
  },
};
</script>

<style scoped>
td,
th {
  text-align: left;
}
th {
  padding-right: 6px;
}
.minWidth {
  width: 300px;
  min-width: 95%;
}
</style>
